import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const validationsExportUrl = ids => `${environment.apiUrl}/validations/export/${ids}`;

@Injectable()
export class ValidationService {
  constructor(private readonly httpService: HttpService) {}

  downloadValidations(contractIds: number[]): Observable<any> {
    return this.httpService.post(validationsExportUrl(contractIds), null);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/validation.service.ts